module.exports = __webpack_public_path__ + "static/podcast2-7d183d7e04f1d14558b5aac6b5d16b51.jpg";